var map = {
	"./PlayAlongNow-Logo_Invert.svg": "./src/assets/images/PlayAlongNow-Logo_Invert.svg",
	"./cancel-confirmation.svg": "./src/assets/images/cancel-confirmation.svg",
	"./icon-announce-schedule.svg": "./src/assets/images/icon-announce-schedule.svg",
	"./icon-app.svg": "./src/assets/images/icon-app.svg",
	"./icon-arrow-down.svg": "./src/assets/images/icon-arrow-down.svg",
	"./icon-arrow.svg": "./src/assets/images/icon-arrow.svg",
	"./icon-basketball-white.svg": "./src/assets/images/icon-basketball-white.svg",
	"./icon-basketball.svg": "./src/assets/images/icon-basketball.svg",
	"./icon-calendar-arrow.svg": "./src/assets/images/icon-calendar-arrow.svg",
	"./icon-calendar.svg": "./src/assets/images/icon-calendar.svg",
	"./icon-check.svg": "./src/assets/images/icon-check.svg",
	"./icon-diagonal-double.png": "./src/assets/images/icon-diagonal-double.png",
	"./icon-dnd.png": "./src/assets/images/icon-dnd.png",
	"./icon-email.svg": "./src/assets/images/icon-email.svg",
	"./icon-filter.svg": "./src/assets/images/icon-filter.svg",
	"./icon-find.svg": "./src/assets/images/icon-find.svg",
	"./icon-football-white.svg": "./src/assets/images/icon-football-white.svg",
	"./icon-football.svg": "./src/assets/images/icon-football.svg",
	"./icon-golf-white.svg": "./src/assets/images/icon-golf-white.svg",
	"./icon-golf.svg": "./src/assets/images/icon-golf.svg",
	"./icon-list-black.svg": "./src/assets/images/icon-list-black.svg",
	"./icon-list.svg": "./src/assets/images/icon-list.svg",
	"./icon-live-stats-goal.svg": "./src/assets/images/icon-live-stats-goal.svg",
	"./icon-lock-black.svg": "./src/assets/images/icon-lock-black.svg",
	"./icon-lock-white.svg": "./src/assets/images/icon-lock-white.svg",
	"./icon-lock.svg": "./src/assets/images/icon-lock.svg",
	"./icon-pen.svg": "./src/assets/images/icon-pen.svg",
	"./icon-profile_default.svg": "./src/assets/images/icon-profile_default.svg",
	"./icon-refresh.svg": "./src/assets/images/icon-refresh.svg",
	"./icon-sms.svg": "./src/assets/images/icon-sms.svg",
	"./icon-time.svg": "./src/assets/images/icon-time.svg",
	"./icon-type.svg": "./src/assets/images/icon-type.svg",
	"./icon-update_save_exit-black.svg": "./src/assets/images/icon-update_save_exit-black.svg",
	"./icon-update_save_exit.svg": "./src/assets/images/icon-update_save_exit.svg",
	"./icon-x.svg": "./src/assets/images/icon-x.svg",
	"./icon_check_white.svg": "./src/assets/images/icon_check_white.svg",
	"./icons8-delete-trash-32.png": "./src/assets/images/icons8-delete-trash-32.png",
	"./import-export-arrows.svg": "./src/assets/images/import-export-arrows.svg",
	"./pa-icon-white.svg": "./src/assets/images/pa-icon-white.svg",
	"./playalong-default.jpg": "./src/assets/images/playalong-default.jpg",
	"./playalong-token.svg": "./src/assets/images/playalong-token.svg",
	"./preplay-sponsor-star6.svg": "./src/assets/images/preplay-sponsor-star6.svg",
	"./preplay-up-arrow-black.svg": "./src/assets/images/preplay-up-arrow-black.svg",
	"./preview/PlayAlongNow-Logo_Invert.svg": "./src/assets/images/preview/PlayAlongNow-Logo_Invert.svg",
	"./preview/icon-lock.svg": "./src/assets/images/preview/icon-lock.svg",
	"./preview/icon-menu.svg": "./src/assets/images/preview/icon-menu.svg",
	"./preview/preview-icon.svg": "./src/assets/images/preview/preview-icon.svg",
	"./preview/star-icon-gold.svg": "./src/assets/images/preview/star-icon-gold.svg",
	"./preview/symbol-prepick.svg": "./src/assets/images/preview/symbol-prepick.svg",
	"./search.png": "./src/assets/images/search.png",
	"./star-icon-dark.svg": "./src/assets/images/star-icon-dark.svg",
	"./timer-circle_full.svg": "./src/assets/images/timer-circle_full.svg"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images recursive ^\\.\\/.*$";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*$
// module id = ./src/assets/images recursive ^\.\/.*$
// module chunks = 6